<template>
    <div class="bill">
        <div class="bill-title">
            <span style="margin-left:20px">我的发票</span>
        </div>
        <div class="bill-top">
            <div class="bill-top-one">可开票金额：</div>
            <div class="bill-top-tow">{{availableMoney}}元</div>
            <div class="bill-top-three" @click="openModal">申请发票</div>
            <div class="line"></div>
            <div class="bill-top-four">
                <p>说明：</p>
                <p>1、订单支付后180天内，可申请发票，超出后不再支持补开发票</p>
                <p>2、系统仅支持电子发票开具</p>
                <p>3、电子发票开具后不可再开纸质发票</p>
                <p>4、发票抬头为实名认证信息，不可更改</p>
            </div>
        </div>
        <div class="bill-top-one" style="margin:0 0 15px 20px;">开票记录</div>
        <Row class="bill-table-title">
            <i-col span="9" style="text-align:left;text-indent:50px;">发票明细</i-col>
            <i-col span="6">订单内容</i-col>
            <i-col span="4">开票状态</i-col>
            <i-col span="5">操作</i-col>
        </Row>
        <div v-if="records.length>0">
            <div style="width:1108px;height:188px;" v-for="(item,index) in records" :key="index">
                <Row class="bill-table-child">
                    <i-col span="9" style="text-align:left;text-indent:25px;">申请时间：{{item.createDate}}</i-col>
                    <i-col v-if="item.status=='complete'" span="6">开票完成时间：{{item.updateDate}}</i-col>
                </Row>
                <Row class="bill-table-body">
                    <i-col span="9" style="text-align:left;text-indent:19px;">
                        <p><span class="span-style">发票总金额：</span>￥{{item.jshj}}元</p>
                        <p><span class="span-style">发票类型：</span>增值税普通电子发票</p>
                        <p><span class="span-style">发票抬头：</span>{{item.gmfMc}}</p>
                        <p><span class="span-style">税号：</span>{{item.gmfNsrsbh && item.gmfNsrsbh!='' ? item.gmfNsrsbh :
                            '-'}}</p>
                    </i-col>
                    <i-col span="6"><p></p>
                        <p>{{item.orderContent}}</p></i-col>
                    <i-col span="4" v-if="item.status=='complete'"><p></p>
                        <p>已开票</p></i-col>
                    <i-col span="4" v-if="item.status=='wait'"><p></p>
                        <p>未开票</p></i-col>
                    <i-col span="4" v-if="item.status=='audit'"><p></p>
                        <p>审核中</p></i-col>
                    <i-col span="4" v-if="item.status=='reject'"><p></p>
                        <p>被驳回</p></i-col>
                    <i-col span="4" v-if="item.status=='expire'"><p></p>
                        <p>已过期</p></i-col>
                    <i-col span="5">
                        <Button v-if="item.status!='reject'" class="down-btn"
                                :style="{cursor:item.status=='complete'? 'pointer':'not-allowed'}"
                                @click="downPdfUrl(item)">下载发票
                        </Button>
                        <Button v-else-if="item.isAfresh != '1'" class="down-btn"
                                :style="{cursor:item.isAfresh == '1' || againBillFlag ? 'not-allowed':'pointer'}"
                                @click="againBill(item)"
                                :disabled="item.isAfresh == '1' || againBillFlag ? true : false">重开发票
                        </Button>
                    </i-col>
                </Row>
            </div>
            <div class="commont-page" style="margin:30px 0;">
                <Page :page-size="pageSize" @on-change="changepage" :total="total" size="small" show-total show-elevator
                      class="page-size-style"></Page>
                <span class="page-total-span">/&nbsp;{{pages}}页</span>
            </div>
        </div>
        <div class="empty-box" v-if="records.length<=0&&flag">
            <img src="@/assets/empty.png" class="empty-img" alt='版权登记'/>
            <p>表单暂无数据哦～</p>
        </div>
        <!-- 申请发票 -->
        <invoicing @fatherModal="fatherModal" @updateBillData="resetData" v-if="showModal" ref="childModal"></invoicing>
    </div>
</template>

<script>
    import Cookies from "js-cookie";
    import invoicing from './invoicing';
    import {_getAmountTotal, _getFindPage, _afreshReceipt} from "@/api/wallet.js";

    export default {
        metaInfo: {
            title: '我的发票|前海版权综合服务平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,前海版权综合服务平台,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '我的发票,前海版权综合服务平台,人人都是创作者，人人都是版权人。前海版权综合服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: 'bill',
        components: {
            invoicing
        },
        data() {
            return {
                total: 0,
                pages: 0,
                pageNumber: 1,
                pageSize: 5,
                records: [],
                flag: false,
                showModal: false,//发票列表弹框
                availableMoney: 0,//可开票金额
                againBillFlag: false //重开发票Flag
            }
        },
        methods: {
            //可开票金额
            getAmountTotal() {
                let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                _getAmountTotal({registerId: userInfo && userInfo.id ? userInfo.id : '',}).then((res) => {
                    if (res.code == 200) {
                        this.availableMoney = res.result
                    } else {
                        toast(res.message)
                    }
                })
            },
            //发票历史订单
            getFindPage() {
                let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                const data = {
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize,
                    registerId: userInfo && userInfo.id ? userInfo.id : '',
                }
                _getFindPage(data).then(res => {
                    if (res.code == 200) {
                        this.total = Number(res.result.total);
                        this.pages = res.result.pages;
                        this.records = res.result.records;
                        this.flag = true;
                    }

                });
            },
            //分页
            changepage(index) {
                this.pageNumber = index;
                this.getFindPage()
            },
            fatherModal() {
                this.showModal = false;
            },
            //下载发票
            downPdfUrl(item) {
                if (item.status == 'complete') {
                    window.open(item.pdfUrl, '_self')
                }
            },
            //申请发票
            openModal() {
                this.showModal = true
            },

            //重置数据
            resetData() {
                this.total = 0;
                this.pages = 0;
                this.pageNumber = 1;
                this.records = [];
                this.getAmountTotal();
                this.getFindPage();
            },

            //重开发票
            againBill(item) {
                this.againBillFlag = true;
                let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                const data = {
                    receiptId: item.id,
                    registerId: userInfo && userInfo.id ? userInfo.id : '',
                };

                _afreshReceipt(data).then(res => {
                    if (res.code == 200) {
                        toast("提交成功");
                        this.againBillFlag = false;
                        this.resetData();
                    } else {
                        toast(res.message)
                        this.againBillFlag = false;
                    }
                })

            }
        },
        mounted() {
            this.getAmountTotal();
            this.getFindPage();
        }
    }
</script>
<style scoped lang="less">
    .bill {
        margin: 20px 25px 25px;
        min-height: 720px;
        position: relative;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 18px 0px rgba(211, 214, 225, 0.15);
        border-radius: 8px;
        overflow: hidden;

        .bill-title {
            height: 63px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
            border-radius: 8px 8px 0px 0px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .bill-top {
            width: 1068px;
            height: 148px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 18px 0px rgba(211, 214, 225, 0.15);
            border-radius: 2px;
            margin: 20px 20px 31px 20px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .bill-top-one {
            font-size: 14px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
        }

        .bill-top-tow {
            font-size: 26px;
            font-weight: 500;
            color: rgba(102, 102, 102, 1);
            margin: 0 63px 0 28px;
        }

        .bill-top-three {
            width: 108px;
            height: 28px;
            line-height: 28px;
            background: rgba(255, 216, 0, 1);
            border-radius: 2px;
            border: 1px solid rgba(255, 216, 0, 1);
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            text-align: center;
            cursor: pointer;
        }

        .line {
            width: 1px;
            height: 120px;
            border: 1px solid rgba(249, 249, 249, 1);
            margin: 0 68px 0 148px;
        }

        .bill-top-four {
            width: 339px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 20px;
        }

        .bill-table-title {
            width: 1108px;
            height: 50px;
            line-height: 50px;
            background: rgba(251, 251, 251, 1);
            font-size: 14px;
            font-weight: 400;
            color: rgba(50, 50, 50, 1);
            text-align: center;
        }

        .bill-table-child {
            width: 1068px;
            height: 30px;
            line-height: 30px;
            background: rgba(241, 241, 241, 1);
            margin: 20px 20px 12px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(50, 50, 50, 1);
        }

        .bill-table-body {
            font-size: 14px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            text-align: center;

            p {
                margin-bottom: 12px;
                height: 21px;
            }

            .span-style {
                display: inline-block;
                width: 84px;
                text-indent: 0;
                margin-right: 6px;
            }

            .down-btn {
                width: 84px;
                height: 33px;
                line-height: 33px;
                background: rgba(246, 246, 246, 1);
                border-radius: 2px;
                border: 1px solid rgba(239, 239, 239, 1);
                font-size: 12px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                position: relative;
                top: 25px;
                margin: auto;
            }

            .down-btn:hover {
                background: #FFD800;
                border: 1px solid 1px solid #FFD800;
            }
        }
    }
</style>
